//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const signalR = require("@microsoft/signalr");
import Cookies from "@/utils/cookie";
import { configs } from "@/configs";
import { battleRoyaleRoom, joinBattleRoyaleSeat, fillBattleRoyaleAiSeat, startBattleRoyaleRoom, chooseBattleRoyaleNumber } from "@/api/battleRoyale";
export default {
  data() { return { activeRoom: null, selectedNumber: null, secondsLeft: 15, serverClockOffsetMs: 0, busy: false, errorMessage: "", connection: null, timer: null, lastFallbackRefresh: 0 }; },
  computed: {
    userId() { return Number(this.$store.state.user.id || 0); },
    isHost() { return this.activeRoom && Number(this.activeRoom.hostPlayerId) === this.userId; },
    currentPlayer() { return this.activeRoom && this.activeRoom.players.find(x => Number(x.accountId) === this.userId); },
    winners() { return this.activeRoom ? this.activeRoom.players.filter(x => x.isWinner) : []; },
    alivePlayers() { return this.activeRoom ? this.activeRoom.players.filter(x => x.isAlive) : []; },
    chosenAliveCount() { return this.alivePlayers.filter(x => x.hasChosen).length; },
    hostName() { const host = this.activeRoom && this.activeRoom.players.find(x => Number(x.accountId) === Number(this.activeRoom.hostPlayerId)); return this.isHost ? "你" : host ? host.displayName : "未知"; },
    // 战位固定按编号渲染，空位也会保留，避免玩家加入后布局跳动。
    seats() { const players = (this.activeRoom && this.activeRoom.players) || []; const max = (this.activeRoom && this.activeRoom.maxPlayerCount) || 6; return Array.from({ length: max }, (_, index) => ({ no: index + 1, player: players.find(x => x.seatNo === index + 1) })); },
    currentPool() { const round = this.activeRoom && this.activeRoom.rounds.find(x => x.roundNo === this.activeRoom.currentRound); return round ? round.numberPool : []; },
    canChoose() { return this.activeRoom && this.activeRoom.state === "Choosing" && this.secondsLeft > 0 && this.currentPlayer && this.currentPlayer.isAlive && this.selectedNumber == null; },
    showChambers() { return this.activeRoom && ["Choosing", "Resolving", "Settling"].includes(this.activeRoom.state); },
    latestExplodedRoom() { const rounds = this.activeRoom ? this.activeRoom.rounds.filter(x => x.targetNumber != null) : []; return rounds.length ? rounds[rounds.length - 1].targetNumber : null; },
    chamberInstruction() { if (this.activeRoom.state !== "Choosing") return "危险舱即将引爆，舱内所有参战者都会出局。"; if (this.secondsLeft <= 5) return "警告：爆破程序即将启动，立即锁定生存舱。"; return "每轮一个生存舱会被引爆。观察其他参战者，然后做出你的选择。"; },
    stateText() { return { Waiting: "等待集结", Starting: "扣除入场筹码", Choosing: "生存舱开放", Resolving: "爆破程序启动", Settling: "奖池清算", Finished: "战局结束", Cancelled: "战局中止" }[this.activeRoom && this.activeRoom.state] || (this.activeRoom && this.activeRoom.state); },
  },
  created() { this.loadRoom(); this.timer = setInterval(this.tick, 500); },
  beforeDestroy() { clearInterval(this.timer); if (this.connection) this.connection.stop(); },
  methods: {
    unwrap(response) { return response.data && (response.data.data || response.data.Data); },
    formatCoin(value) { return Number(value || 0).toFixed(2); },
    chamberCode(number) { return Number(number) < 10 ? `0${number}` : String(number); },
    chamberPlayers(number) { return this.activeRoom ? this.activeRoom.players.filter(player => player.isAlive && player.selectedNumber === number) : []; },
    playerStatus(player) { const room = player.selectedNumber == null ? "" : `${player.selectedNumber} 号舱`; if (player.isWinner) return `最后幸存者 +${this.formatCoin(player.payoutAmount)}`; if (!player.isAlive) return room ? `爆炸出局 · ${room}` : "已经出局"; if (!this.activeRoom || this.activeRoom.state !== "Choosing") return "仍在战场"; return player.hasChosen ? `已进入 ${room}` : player.isAi ? "AI 正在扫描" : "尚未进入生存舱"; },
    async run(action) { this.busy = true; this.errorMessage = ""; try { return await action(); } catch (error) { this.errorMessage = error.response?.data?.msg || error.message || "指令执行失败"; throw error; } finally { this.busy = false; } },
    applyRoom(room, resetChoice = false) {
      const changedRound = !this.activeRoom || room.currentRound !== this.activeRoom.currentRound;
      if (resetChoice || changedRound) this.selectedNumber = room.myChoiceNumber == null ? null : room.myChoiceNumber;
      // 使用服务端 UTC 毫秒校正本机时钟，倒计时不依赖本地时区。
      this.serverClockOffsetMs = Number(room.serverTimeUtcMs) - Date.now();
      this.activeRoom = room;
      this.tick();
    },
    async loadRoom() { try { this.applyRoom(this.unwrap(await battleRoyaleRoom(this.$route.params.roomId)), true); await this.connect(); } catch (_) {} },
    async connect() { this.connection = new signalR.HubConnectionBuilder().withUrl(`${configs.serveBaseURL.replace(/(.*)\/api/, "$1/hubs")}/BattleRoyale`, { accessTokenFactory: () => Cookies.getToken() }).withAutomaticReconnect([1000, 2000, 5000]).configureLogging(signalR.LogLevel.Error).build(); this.connection.on("RoomSnapshot", room => { this.applyRoom(room); if (room.state === "Finished") this.$store.commit("setInfo"); }); this.connection.onreconnected(() => this.activeRoom && this.connection.invoke("Subscribe", this.activeRoom.roomId)); try { await this.connection.start(); await this.connection.invoke("Subscribe", this.activeRoom.roomId); } catch (_) { this.connection = null; } },
    tick() {
      if (this.activeRoom && this.activeRoom.deadlineAtUtcMs != null) this.secondsLeft = Math.max(0, Math.ceil((Number(this.activeRoom.deadlineAtUtcMs) - Date.now() - this.serverClockOffsetMs) / 1000));
      if ((!this.connection || this.connection.state !== "Connected") && Date.now() - this.lastFallbackRefresh > 3000) {
        this.lastFallbackRefresh = Date.now();
        battleRoyaleRoom(this.$route.params.roomId).then(response => this.applyRoom(this.unwrap(response))).catch(() => {});
      }
    },
    async joinSeat(seatNo) { const action = this.isHost ? () => fillBattleRoyaleAiSeat(this.activeRoom.roomId, seatNo) : () => joinBattleRoyaleSeat(this.activeRoom.roomId, { seatNo }); const response = await this.run(action); this.applyRoom(this.unwrap(response)); },
    async startRoom() { const response = await this.run(() => startBattleRoyaleRoom(this.activeRoom.roomId)); this.applyRoom(this.unwrap(response)); },
    async choose(number) { const response = await this.run(() => chooseBattleRoyaleNumber(this.activeRoom.roomId, { number })); this.selectedNumber = number; this.applyRoom(this.unwrap(response)); },
    backToLobby() { this.$router.push({ name: "battleRoyale" }); },
  },
};
